import React from 'react';

type SpinnerProps = {
    size?: number;
    className?: string;
    style?: React.CSSProperties;
    'aria-label'?: string;
    inProgress?: boolean;
};

const Spinner: React.FC<SpinnerProps> = ({
    size = 24,
    className = '',
    style,
    'aria-label': ariaLabel = 'Loading...',
    inProgress = true,
}) => {
    if (!inProgress) return null;
    return (
        <span
            className={`spinner ${className}`}
            style={{
                display: 'inline-block',
                verticalAlign: 'middle',
                width: size,
                height: size,
                ...style,
            }}
            role="status"
            aria-label={ariaLabel}
        >
            <svg
                width={size}
                height={size}
                viewBox="0 0 50 50"
                style={{ display: 'block' }}
            >
                <circle
                    cx="25"
                    cy="25"
                    r="20"
                    fill="none"
                    stroke="#1976d2"
                    strokeWidth="5"
                    strokeLinecap="round"
                    strokeDasharray="80"
                    strokeDashoffset="60"
                />
            </svg>
            <style>
                {`
                    .spinner svg {
                        animation: spinner-rotate 0.8s linear infinite;
                    }
                    @keyframes spinner-rotate {
                        100% { transform: rotate(360deg);}
                    }
                `}
            </style>
        </span>
    );
};

export default Spinner;
